"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@cc-plugins/api");
